export default __webpack_public_path__ + "static/media/left.e1553cb5.svg";